export default "__VITE_ASSET__hLY3zDOp__"